// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"4ac0b80d","453":"ffc3f7cc"}[chunkId] + ".chunk.js";
};